(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@makolab/library-react/dist/console"] = factory();
	else
		root["@makolab/library-react/dist/console"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/project_fcn_library-react/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 84);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = require("lodash/has");

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

module.exports = require("process/browser.js");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("lodash/noop");

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROP_TYPE_CONSOLE", function() { return PROP_TYPE_CONSOLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Console", function() { return Console; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/* globals console */var LOG_LEVELS={ALL:0,DEBUG:1,INFO:2,WARN:3,ERROR:4,FATAL:5,OFF:6,0:'ALL',1:'DEBUG',2:'INFO',3:'WARN',4:'ERROR',5:'FATAL',6:'OFF'};var logLevel=__WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(LOG_LEVELS,process.env.REACT_APP_LOG_LEVEL)?process.env.REACT_APP_LOG_LEVEL:6;var CURRENT_LOG_LEVEL=LOG_LEVELS[logLevel];var DEBUG_MODE=process.env.REACT_APP_DEBUG_MODE!==false;var dateColor='color: green;';var logStyles={DEBUG:'color: #873af9;',INFO:'color: #000066;',WARN:'color: orange;',ERROR:'color: red;',FATAL:'color: white; background: red;'};var isLogLevelMatching=function isLogLevelMatching(type){var tmpType=type;var TYPE=__WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(LOG_LEVELS,tmpType)?LOG_LEVELS[tmpType]:LOG_LEVELS.OFF;if(CURRENT_LOG_LEVEL===LOG_LEVELS.ALL){return true;}if(CURRENT_LOG_LEVEL===LOG_LEVELS.OFF||TYPE===LOG_LEVELS.OFF){return false;}return CURRENT_LOG_LEVEL>=LOG_LEVELS[TYPE];};/**
 * Used to format date in log message.
 * @returns {string}
 */var formatDate=function formatDate(){var colored=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;var t=new Date();var returnDate=void 0;var addZeroPrefix=function addZeroPrefix(number){return number>10?''+number:'0'+number;};var monthDisplay=addZeroPrefix(t.getUTCMonth()+1);var dayDisplay=addZeroPrefix(t.getUTCDate());var hoursDisplay=addZeroPrefix(t.getUTCHours());var minutesDisplay=addZeroPrefix(t.getUTCMinutes());var secondsDisplay=addZeroPrefix(t.getUTCSeconds());returnDate=(colored?'%c':'')+'UTC '+t.getUTCFullYear()+'-'+monthDisplay+'-'+dayDisplay+' ';returnDate+=hoursDisplay+':'+minutesDisplay+':'+secondsDisplay;return returnDate;};var logMessage=function logMessage(type){return formatDate()+' %c'+LOG_LEVELS[LOG_LEVELS[type]];};var PROP_TYPE_CONSOLE=__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({debug:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,log:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,info:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,warn:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,error:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,fatal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired});/**
 * Class for logging on standard console based on: https://robferguson.org/blog/2017/09/09/a-simple-logging-service-for-angular-4/
 * REACT_APP_DEBUG_MODE - turn off/on logging
 * REACT_APP_LOG_LEVEL - determine what kind of messages should be logged. These variables comes from environment file
 * Example usage:
 * this.logger.info('[AppComponent]', 'logger.info()', ["example", 'message']); //Only 1 argument is mandatory, other are optional.
 */var Console=function(){function Console(){_classCallCheck(this,Console);}_createClass(Console,[{key:'debug',/**
   * Used form logging messages of type LogLevel.Debug.
   * Function binds context to file when method for logger was call.
   * @returns {function}
   */get:function get(){var type='DEBUG';if(DEBUG_MODE||isLogLevelMatching(type)){return console.debug.bind(console,logMessage(type),dateColor,logStyles[type]);}return __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a;}/**
   * Used form logging messages of type LogLevel.Info.
   * Function binds context to file when method for logger was call.
   * @returns {function}
   */},{key:'log',get:function get(){var type='INFO';if(DEBUG_MODE||isLogLevelMatching(type)){return console.log.bind(console,logMessage(type),dateColor,logStyles[type]);}return __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a;}/**
   * Used form logging messages of type LogLevel.Debug.
   * Function binds context to file when method for logger was call.
   * @returns {function}
   */},{key:'info',get:function get(){var type='INFO';if(DEBUG_MODE||isLogLevelMatching(type)){return console.info.bind(console,logMessage(type),dateColor,logStyles[type]);}return __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a;}/**
   * Used form logging messages of type LogLevel.Warn.
   * Function binds context to file when method for logger was call.
   * @returns {function}
   */},{key:'warn',get:function get(){var type='WARN';if(DEBUG_MODE||isLogLevelMatching(type)){return console.warn.bind(console,logMessage(type),dateColor,logStyles[type]);}return __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a;}/**
   * Used form logging messages of type LogLevel.Error.
   * Function binds context to file when method for logger was call.
   * @returns {function}
   */},{key:'error',get:function get(){var type='ERROR';if(DEBUG_MODE||isLogLevelMatching(type)){return console.error.bind(console,logMessage(type),dateColor,logStyles[type]);}return __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a;}/**
   * Used form logging messages of type LogLevel.Fatal.
   * Function binds context to file when method for logger was call.
   * @returns {function}
   */},{key:'fatal',get:function get(){var type='FATAL';if(DEBUG_MODE||isLogLevelMatching(type)){return console.error.bind(console,logMessage(type),dateColor,logStyles[type]);}return __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a;}}]);return Console;}();/* harmony default export */ __webpack_exports__["default"] = (new Console());
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(23)))

/***/ })

/******/ });
});
//# sourceMappingURL=console.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@makolab/library-react/dist/console.js
// module id = 145
// module chunks = 0